// /* eslint-disable jsx-a11y/anchor-is-valid */
// import { useEffect, useState } from 'react'
// // import {Get_Property_Type, Get_Carpet_Unit} from './Property_Api'
// // import './propertyNewHome_styles/propertyNewHome.css'
// import { FormikValues } from 'formik'
// // import {propertyTypeDataType, carpetAreaUnitDataType} from './PropertyDataTypes'
// import Swal from 'sweetalert2'

// const ViewLeadStep3 = () => {
//     return (
//         <div data-kt-stepper-element='content'>
//             <div className='w-100'>
//                 step3
//             </div>
//         </div>
//     )
// }

// export default ViewLeadStep3

import React, {useEffect, useState} from 'react'
import LeadsDetailsForm from '../../../modules/auth/components/LeadsDetailsForm'
import {generateLeadFormID} from '../LeadManagementAPI'
import img from '../../property/submit-property.png'

const ViewLeadStep3 = ({
  acceptedProperty,
  setError,
  getLeadList,
  id,
  genLeadFormIDLoading,
  setId,
  setSuccessfullySubmitted,
  successfullySubmitted,
  data,
}: any) => {
  console.log('AAAAA12345', acceptedProperty)
  console.log('data3', data)
  //     {
  //   handleClose,
  //   setId,
  //   id,
  //   getLeadList,
  // }: any
  const [isCopied, setIsCopied] = useState<boolean>(false)
  // const [id, setId] = useState<string | null>(null)
  // const [genLeadFormIDLoading, setGenLeadFormIDLoading] = useState<boolean>(false)
  // function to copy the leads form link to the clipboard
  const copyToClipboard = () => {
    if (id) {
      navigator.clipboard
        .writeText(`${process.env.REACT_APP_TENANT_FORM_BASE_URL}/${id}`)
        .then(() => {
          setIsCopied(true)
          setTimeout(() => {
            setIsCopied(false)
          }, 3000)
        })
        .catch((error) => {
          console.error('Failed to copy:', error)
        })
    }
  }

  // acceptedProperty[0].leads_property_uuid
  return (
    <div data-kt-stepper-element='content'>
      <div className='w-100'>
        {/* Begin: Modal header */}
        {/* <div className='modal-header pt-5 pb-5'>
        {/* Begin: Modal Heading */}
        {/* <h2>Confirm Booking</h2> */}
        {/* End: Modal Heading 
        {/* Begin::Close button 
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <i className='bi bi-x-lg' onClick={handleClose}></i>
        </div>
        {/* end::Close button 
      </div> */}
        {/* End: Modal header */}

        {/* Begin: Modal body */}

        {successfullySubmitted ? (
          <div>
            <div className='w-100 text-center'>
              {/* begin::Illustration */}
              <div className='text-center'>
                <img src={img} alt='img' className='mw-100 mh-300px' />
              </div>
              {/* end::Illustration */}
              {/* begin::Heading */}
              <h1 className='fw-bold text-dark mb-3'>Success!</h1>
              {/* end::Heading */}
              {/* begin::Description */}
              <div className='text-muted fw-semibold fs-3'>
                Booking details submitted successfully
              </div>
              {/* end::Description */}
            </div>
          </div>
        ) : (
          <div className='modal-body p-0'>
            {/* Begin: copy form link button */}
            <div className='d-flex mt-4 justify-content-between px-10'>
              <h4 className='text-primary'>Confirm Booking</h4>
              <div>
                {id ? (
                  <button
                    onClick={copyToClipboard}
                    className='btn btn-sm btn-primary me-4 mb-2'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_offer_a_deal'
                  >
                    {isCopied ? (
                      <i className='bi bi-clipboard-check me-2 my-0 p-0 fs-5'></i>
                    ) : (
                      <i className='bi bi-clipboard me-2 my-0 p-0 fs-5'></i>
                    )}
                    <span>{isCopied ? 'Copied!' : 'Copy Form Link'}</span>
                  </button>
                ) : (
                  <button
                    className='btn btn-sm btn-primary me-6 mb-2'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_offer_a_deal'
                  >
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Loading...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  </button>
                )}
              </div>
            </div>
            {id && (
              <LeadsDetailsForm
                id={id}
                closeForm={() => setId(null)}
                getLeadList={getLeadList}
                outsideForm={false}
                setSuccessfullySubmitted={setSuccessfullySubmitted}
                data={data}
              />
            )}
          </div>
        )}
        {/* End: Modal body */}
      </div>
    </div>
  )
}

export default ViewLeadStep3
